<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-md-3.col-2
        b-input-group(size="sm")
          b-input-group-text(slot="prepend" :title="$t('ui.signup_bonus')")
            span {{ $t('ui.signup_bonus') }}
          b-input-group-text(slot="append")
            label.custom-switch
              input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="signupBonus" @change="getLogList(true)")
              span.custom-switch-indicator 
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.amount') }}
          b-form-select(v-model="filterAmount" @change="getLogList(true)" :disabled="loading" size="sm")
            option(value="1") {{ $t('ui.all') }}
            option(value="2") {{ $t('ui.credit') }}
            option(value="3") {{ $t("ui.debit") }}              
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLogList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th.text-right(width="15%")
                  span(:title="$t('ui.balance_before')") {{ $t('ui.balance_before') }}
                th.text-right(width="15%" @click="sortOrder('amount')")
                  span(:title="$t('ui.amount')") {{ $t('ui.amount') }}
                  .float-right
                    i(:class="changeSortKey('amount')")
                th.text-right(width="15%")
                  span(:title="$t('ui.balance_after')") {{ $t('ui.balance_after') }}
                th(width="17%" @click="sortOrder('remark')")
                  span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                  .float-right
                    i(:class="changeSortKey('remark')")
                th(width="11%" @click="sortOrder('created_by')")
                  span(:title="$t('ui.created_by')") {{ $t('ui.created_by') }}
                  .float-right
                    i(:class="changeSortKey('created_by')")
                th.text-right(width="13%" @click="sortOrder('created_date')")
                  span(:title="$t('ui.created_date')") {{ $t("ui.created_date") }}
                  .float-right
                    i(:class="changeSortKey('created_date')")
            tbody.clusterize-content
              tr(v-if="logList.length == 0")
                td(:colspan="8").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in logList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.balance_before)" :title="$n(item.balance_before, 'currency')") {{ $n(item.balance_before, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.amount)" :title="$n(item.amount, 'currency')") {{ $n(item.amount, 'currency') }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(item.balance_after)" :title="$n(item.balance_after, 'currency')") {{ $n(item.balance_after, 'currency') }}
                td
                  span(:title="item.remark") {{ item.remark }}&nbsp;
                td
                  span(:title="item.created_by") {{ item.created_by }}&nbsp;
                td.text-right
                  span(:title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
              tr(v-if="showTotal")
                td.text-right(colspan="3")
                  span {{ $t("ui.sub_total") }}
                  br
                  span {{ $t("ui.grand_total") }}
                td.text-right
                  span.font-weight-bold(:class="$helpers.fontClassName(subTotalAmount)" :title="$n(subTotalAmount, 'currency')") {{ $n(subTotalAmount, 'currency') }}
                  br
                  span.font-weight-bold(:class="$helpers.fontClassName(grandTotalAmount)" :title="$n(grandTotalAmount, 'currency')") {{ $n(grandTotalAmount, 'currency') }}
                td(colspan="4")

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    currentPage: 1,
    totalRow: 0,
    logList: [],
    startDate: null,
    endDate: null,
    dateRange: {
      startDate: null,
      endDate: null
    },
    sortKey: "created_date",
    sortType: "desc",
    showTotal: false,
    subTotalAmount: 0,
    grandTotalAmount: 0,
    signupBonus: false,
    filterAmount: 1
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberLog;
    }
  },
  mounted: function() {},
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null,
      signup_bonus: null,
      filter_amount: 1,
    };
    this.$store.dispatch("user/setAdjustmentLogParam", json);
  },
  methods: {
    refresh() {
      if (this.$store.getters.adjustmentLog.signup_bonus != null && this.$store.getters.adjustmentLog.signup_bonus != '') {
        this.signupBonus = this.$store.getters.adjustmentLog.signup_bonus;
      }
      if (this.$store.getters.adjustmentLog.filter_amount != null && this.$store.getters.adjustmentLog.filter_amount != '') {
        this.filterAmount = this.$store.getters.adjustmentLog.filter_amount;
      }
      if (this.$store.getters.adjustmentLog.start_date && this.$store.getters.adjustmentLog.end_date) {
        this.dateRange.startDate = this.$store.getters.adjustmentLog.start_date;
        this.dateRange.endDate = this.$store.getters.adjustmentLog.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getLogList(true);
    },
    setAdjustmentLogParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        signup_bonus: this.signupBonus,
        filter_amount: this.filterAmount
      };
      this.$store.dispatch("user/setAdjustmentLogParam", json);
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
    },
    getLogList: function(isSearch) {
      if (this.checkDateRange()) {
        this.setAdjustmentLogParam();
        let url = config.adjustmentListUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.memberID,
          is_sb: this.signupBonus,
          filter_amount: this.filterAmount,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotal()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.dt.length > 0) {
                    this.showTotal = true;
                    response.data.dt.forEach(value => {
                      this.subTotalAmount = parseFloat(this.subTotalAmount) + parseFloat(value["amount"]);
                    });

                    this.logList = response.data.dt;
                    this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
                    this.grandTotalAmount = this.logList.length > 0 ? this.logList[0].total_amount : 0;
                  }
                  else {
                    this.clearTotal();
                  }
                } else {
                  this.clearTotal();
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.logList = [];
        this.clearTotal();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    clearTotal() {
      this.showTotal = false
      this.logList = []
      this.totalRow = 0
      this.subTotalAmount = 0
      this.grandTotalAmount = 0
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'adjustmentlog') return
      this.$store.dispatch("layout/setPageSizeMemberLog", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>